// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1d5hQ","buttons":"Footer_buttons__3fhXI"};